export var ContextGLCompareMode;
(function (ContextGLCompareMode) {
    ContextGLCompareMode[ContextGLCompareMode["ALWAYS"] = 0] = "ALWAYS";
    ContextGLCompareMode[ContextGLCompareMode["EQUAL"] = 1] = "EQUAL";
    ContextGLCompareMode[ContextGLCompareMode["GREATER"] = 2] = "GREATER";
    ContextGLCompareMode[ContextGLCompareMode["GREATER_EQUAL"] = 3] = "GREATER_EQUAL";
    ContextGLCompareMode[ContextGLCompareMode["LESS"] = 4] = "LESS";
    ContextGLCompareMode[ContextGLCompareMode["LESS_EQUAL"] = 5] = "LESS_EQUAL";
    ContextGLCompareMode[ContextGLCompareMode["NEVER"] = 6] = "NEVER";
    ContextGLCompareMode[ContextGLCompareMode["NOT_EQUAL"] = 7] = "NOT_EQUAL";
})(ContextGLCompareMode || (ContextGLCompareMode = {}));
